module.exports = __webpack_public_path__ + "static/media/how-to-use-aligners.aab20cdc.mp4";